import Vue from 'vue'
import Router from 'vue-router'
import RetailerHome from '@/views/RetailerHome'
import UploadCollection from '@/views/UploadCollection'
import Analytics from '@/views/Analytics'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: RetailerHome
    },
    {
      path: '/upload',
      name: 'upload',
      component: UploadCollection
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics
    }
  ]
})

export default router;
